import { render, staticRenderFns } from "./FixedSalaryTable.vue?vue&type=template&id=a8834b1a&"
import script from "./FixedSalaryTable.vue?vue&type=script&lang=js&"
export * from "./FixedSalaryTable.vue?vue&type=script&lang=js&"
import style0 from "./FixedSalaryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports